module.exports = __webpack_public_path__ + "img/groupHub.1018fa7e.png";